import { actionTypes } from "../actions/user";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER:
      return action.payload;
    default:
      return state;
  }
};

export default variable;